import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { Virtuoso } from 'react-virtuoso'

import './textResponseChart.scss'

@observer
class TextResponseChart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentYear: undefined,
        }
    }

    renderResponses = () => {
        const { chartData, defaultYear, iconColour } = this.props
        const { currentYear } = this.state
        if (!currentYear && !defaultYear) return null
        const selectedYear = currentYear || defaultYear
        const yearData = chartData.find((d) => d.year === selectedYear)
        const sortedData = R.pathOr([], ['data'], yearData)
            .slice()
            .sort((a, b) => (a.numberOfResponses ? b.numberOfResponses - a.numberOfResponses : 0))

        return (
            <div style={{
                height: '100%', overflow: 'hidden', boxSizing: 'border-box',
            }}
            >
                <Virtuoso
                    style={{ height: '100%' }}
                    data={sortedData}
                    itemContent={(index, r) => (
                        <div className="response">
                            <div className="responseIcon">
                                <i className="fa-solid fa-quote-left" style={{ color: iconColour || '#16CCC1' }} />
                            </div>
                            <div className="responseText">{r.response}</div>
                            <div className="responseCount">
                                (
                                {r.numberOfResponses}
                                )
                            </div>
                        </div>
                    )}
                />
            </div>
        )
    }

    renderYearSelector = () => {
        const { years, defaultYear } = this.props
        const { currentYear } = this.state
        if (!years || years.length === 1) return null
        const selectedYear = currentYear || defaultYear
        const sortedYears = years.sort((a, b) => b - a)
        return (
            <div className="yearSelector">
                {sortedYears.map((y) => (
                    <div className={`year ${selectedYear === y ? 'active' : ''}`} onClick={() => this.setState({ currentYear: y })}>{y}</div>
                ))}
            </div>
        )
    }

    render() {
        const {
            title,
            height,
        } = this.props

        return (
            <div className="textResponseChart" style={{ height: `${height}px`, display: 'flex', flexDirection: 'column' }}>
                <div className="header">{title}</div>
                {this.renderYearSelector()}
                <div className="responses" style={{ flex: 1 }}>{this.renderResponses()}</div>
            </div>
        )
    }
}

export default TextResponseChart
